import React, { Component } from 'react';
import { render } from 'react-dom';
import { arrayMove, SortableElement, SortableContainer } from 'react-sortable-hoc';
import { Select } from 'antd';

const gridStyles = (columns) =>( {
  display: 'grid',
  width: `${columns * 150}px`,
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
  gridGap: '16px',
  alignItems: 'end'
});

const gridItemStyles = {
  display: 'flex',
  height: '80px',
  width: '150px',
  backgroundColor: '#e5e5e5',
  borderRadius: '10px',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  boxShadow: '5px 6px gray'
};

const GridItem = SortableElement(({ value }) =>
  <div style={{ ...gridItemStyles, backgroundColor: value.color_code, color: getCorrectTextColor(value.color_code || '#E8E7E6')}}>
    {value.name}
  </div>
);

const Grid = SortableContainer(({ items, displayColumns }) =>
  <div style={gridStyles(displayColumns)}>
    {items.map((value, index) =>
      <GridItem
        key={`item-${index}`}
        index={index}
        value={value}
      />
    )}
  </div>
);

export default class App extends Component {
  state = {
    items: [] //Array.apply(null, Array(100)).map((val, index) => `Item ${index}`),
  };
  componentDidMount() {
    this.setState({ loading: true });
    var url = Spree.url('/api/v1/products?type=is_pos_item', {
      token: Spree.api_key
    });
    const $this = this;
    return $.getJSON(url, null, function (data) {

      const items = data.products.map((product, index) => ({ index: index, ...product }));

      $this.setState({ items });
      console.log("data", items);
      $this.setState({ loading: false });

    });

  }
  renderSelectionList = () => {
    const { categories } = this.props
    if(categories){
      <Select
        showSearch
        style={{ minWidth: 300 }}
        placeholder="Select a category"
        optionFilterProp="children"
        onChange={accountSelectedHandler}
      >
        {categories.map((cat, index) => <Option key={index} value={cat.id}>{cat.name}</Option>)}
      </Select>
    }
    else{
      return ""
    }
  }
  
  onSortEnd = ({ oldIndex, newIndex }) => {
    const items = arrayMove(this.state.items, oldIndex, newIndex)
    this.setState({
      items,
    });
    const $this = this;
    $.ajax({
      type: "POST",
      dataType: 'json',
      url: '/api/v1/products/update_position?type=is_pos_item',
      data: {
        "products": items, token: Spree.api_key
      },
      success: function (data) {
        const items = data.products.map((product, index) => ({ index: index, ...product }));
        $this.setState({ items });

      }
    });
    console.log('items', items)
  };

  render() {
    return (
      <div>
        {this.renderSelectionList()}
      <Grid items={this.state.items} 
        onSortEnd={this.onSortEnd} 
        axis="xy" 
        displayColumns = {this.props.columns} 
      />
      </div>
    );
  }
}


